import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { SystemService } from 'src/app/service/system.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-update-region',
  templateUrl: './update-region.component.html',
  styleUrls: ['./update-region.component.scss']
})
export class UpdateRegionComponent implements OnInit {
  showLoader: boolean = false;
  disabled = false;
  ShowFilter = true;
  limitSelection = false;
  updating: boolean = false;
  regionId: any;
  countryId: any;
  countries: any;

  editRegion = new FormGroup({
    country: new FormControl('', [
      Validators.required,
    ]),
    regionNameAr: new FormControl('', [
      Validators.required,
    ]),
    regionNameEn: new FormControl('', [
      Validators.required,
    ])
    // dictId: new FormControl('', [
    //   Validators.required,
    // ])
  });

  constructor(public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, public systemService: SystemService, private toastrService: ToastrService
    , public translate: TranslateService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.regionId = params['regionID'] || "";

        if (this.regionId != "") {
          this.showLoader = true;
          this.getAllCountries();
          // Get region
          this.getRegion();
        } else {
          console.log("no region");
          this.router.navigate(['/system/regions']);
        }
      });
  }
  editRegionSubmit() {
    if (this.editRegion.valid) {
      let country = this.editRegion.controls.country?.value;
      let regionNameAr = this.editRegion.controls.regionNameAr?.value;
      let regionNameEn = this.editRegion.controls.regionNameEn?.value;

      this.updateRegion(country, regionNameAr, regionNameEn);

    }
    else {
      this.editRegion.markAllAsTouched();
      this.editRegion.markAsDirty();
    }
  }

  updateRegion(country: number, regionNameAr: string, regionNameEn: string) {
    this.updating = true;
    this.systemService.updateRegion(this.regionId, country, regionNameAr, regionNameEn).subscribe(
      data => {
        this.router.navigate(['/system/regions']);
        this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
      },
      error => {
        this.updating = false
        this.toastr.error(this.translate.instant('CAN_NOT_UPDATE'));
      },
      () => this.updating = false
    );
  }

  getRegion() {
    this.showLoader = true;
    this.systemService.getRegion(this.regionId)
      .subscribe(
        data => {
          this.editRegion.controls.regionNameAr.setValue(data.regionNameAr);
          this.editRegion.controls.regionNameEn.setValue(data.regionNameEn);
          this.editRegion.controls.country.setValue(data.countryid);
          // this.getCountry();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        },
        () => this.showLoader = false
      );
  }

  getAllCountries() {
    this.systemService.getAllCountries()
      .subscribe(
        data => {
          this.countries = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));

        }
      );

  }

  editRegionChange() {
    // this
  }

  changeCountry() {
    // this
  }

  // getCountry(){
  //   this.systemService.getCountry(this.countryId).subscribe(
  //     data => {

  //     },
  //     error => {
  //       this.toastr.error("can't get region country");
  //     }
  //   );
  // }

}
